// src/components/ProtectedRoute.js

import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user } = useContext(AuthContext);

  if (!user) {
    console.log('[ProtectedRoute] User not logged in, redirecting to login...');
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
